import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import usePocketBaseAuth from "../../hooks/Auth/usePocketBaseAuth";
import LoadingWrapper from "../Widgets/Global/LoadingWrapper";
import { useDispatch, useSelector } from "react-redux";
import { setUser, setLoading } from "../../features/authSlice";

const LoginForm = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const { login } = usePocketBaseAuth();
  const navigate = useNavigate();
  const { isLoading } = useSelector((state) => state.auth);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    dispatch(setLoading(true));
    try {
      const user = await login(email, password);
      if (user) {
        dispatch(setUser(user));
        navigate("/dashboard");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-sm flex flex-col space-y-4">
      <h2 className="text-2xl font-bold mb-2">Sign In</h2>
      <p className="text-gray-600 text-sm">Enter your email and password to log in.</p>

      <input
        type="email"
        placeholder="Email or User Name *"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="border border-gray-300 rounded-md p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
        required
      />

      <input
        type="password"
        placeholder="Password *"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="border border-gray-300 rounded-md p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
        required
      />

      {/* {error && <p className="text-red-500 text-sm">{error}</p>} */}

      {/* <button
        type="submit"
        className="bg-blue-600 text-white py-3 rounded-md hover:bg-blue-700 transition"
      >
        SIGN IN
      </button> */}
      <LoadingWrapper isLoading={isLoading}>
        <button
          type="submit"
          className="bg-[#90c740] text-white py-3 px-6 rounded-md hover:bg-[#7ebd2e] transition"
        >
          SIGN IN
        </button>
      </LoadingWrapper>

      {error && <p className="text-red-500">{error}</p>}
    </form>
  );
};

export default LoginForm;
